import React from 'react';
import Icon from '../../../Icons/Icon';

const ValidationHint = ({isValid, validatable}) => {
    if (validatable === false) {
        return null;
    }

    if (isValid) {
        return <Icon icon="Check"  size="0.5x" inline className="ml-1 fill-brand" />
    }

    return <span className="ml-1 text-red-600">*</span>
}

export default ValidationHint;